import { MailSendCompletePage } from '@/src/components/pages/MailSendCompletePage'

const Page = () => <MailSendCompletePage />

export default Page
